import { useAlert, useNotification } from '@btime/react-messager'
import { useMutation, gql } from '@apollo/client'
import { useTranslation } from 'react-i18next'

import { generalClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation RemoveScreenItem($id: Int) {
    removeScreenItem(id: $id)
  }
`

export const useRemoveScreenItem = () => {
  const { t } = useTranslation('common')
  const notify = useNotification()
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['Screens'],
    client: generalClient
  })
  const modal = useAlert()

  const handleRequest = id => {
    if (!modal.confirm({ title: t('widgets.removeScreenItem.confirm') })) return false

    return request({ variables: { id } }).then(resp => {
      if (!resp.errors) {
        notify.success({ title: t('widgets.removeScreenItem.success') })
      } else {
        notify.error({ title: t('widgets.removeScreenItem.error') })
      }
    })
  }

  return [handleRequest, state]
}
